import React from "react";

import ImageComparisonSlider from "@components/molecules/ImageComparisonSlider";

import { ImageComparisonSliderStoryblokProps } from "./types";

const ImageComparisonSliderStoryblok: React.FC<
  ImageComparisonSliderStoryblokProps
> = ({ blok }) => {
  const { items } = blok;

  if (!items.length) {
    return null;
  }

  return <ImageComparisonSlider {...{ items }} />;
};

export default ImageComparisonSliderStoryblok;
